export default "/images/vendor/flag-icon-css/flags/1x1/gy.svg?43c003e277ed5a4d0ca0ccb9dc4515fd";